const Payu = () => {

    window.addEventListener('load', function() {

        setTimeout(() => {
            const singleProductPrice = document.querySelector('.single-product .single_variation_wrap .price ins .woocommerce-Price-amount bdi, .single-product.postid-9497 .single_variation_wrap .price .woocommerce-Price-amount bdi');
            const payuWrapper = document.getElementsByClassName('payu-raty-wrapper')[0];
            
            if(singleProductPrice) {
                let price = singleProductPrice.innerText.replace(/ /g,'').replace(',','.').replace('zł','').trim();
                let value = Number(price);
                if (value >= 300 && value <= 50000) {

                    if(payuWrapper) {
                        payuWrapper.classList.remove('d-none');
                    }

                    var options = {
                        creditAmount: value,    // wartość jako number (w PLN)
                        posId: '4169567',         // identyfikator punktu płatności
                        key: '2b',              // pierwsze dwa znaki klucza api
                        // showLongDescription: true
                    };
                    console.log(OpenPayU);
                    OpenPayU.Installments.miniInstallment('#installment-mini', options)
                        .then(function(result) {
                            // Ten fragment kodu zostanie wykonany po pokazaniu widżetu 
                            // obiekt 'result' przekazany w parametrze funkcji udostępnia dodatkowe opcje; 
                            // przykładowe użycie w FAQ pkt. 6 
                        })
                        .catch(function(e)  {
                            console.error(e.toString()); // Wypisanie błędów konfiguracji na konsolę 
                        });
                }
            }
        }, 500);

    })

}

export default Payu;